export enum IsfType {
  ISF_10 = 'ISF_10',
  ISF_5 = 'ISF_5',
}
